import { Controller } from "@hotwired/stimulus"

// Keeps a click inside a clickable row (a <tr> that opens a drawer or expands a
// detail panel) from also triggering the row. Replaces inline
// onclick="event.stopPropagation()" handlers, which AGENTS.md forbids.
//
// Usage:
//   data-controller="stop-propagation" data-action="click->stop-propagation#stop"
export default class extends Controller {
  stop(event) {
    event.stopPropagation()
  }
}
